export default __webpack_public_path__ + "static/media/Ava 9781408309063.3d2b01be.jpg";